import type React from 'react'

// biome-ignore lint/suspicious/noShadowRestrictedNames: Symbol is a domain component name
const Symbol: React.FC = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.03 12.2395C41.3941 10.5868 38.6059 10.5868 36.97 12.2395L12.1049 37.3605C10.6317 38.8488 10.6317 41.1512 12.1049 42.6395L36.97 67.7605C38.6059 69.4132 41.3941 69.4132 43.03 67.7605L67.8951 42.6395C69.3683 41.1512 69.3683 38.8488 67.8951 37.3605L43.03 12.2395ZM40 16.4184L30.1704 26.3448L40.0001 36.1745L49.8297 26.345L40 16.4184ZM53.6366 30.1893L43.8258 40.0001L53.6365 49.8108L63.3516 40L53.6366 30.1893ZM36.1745 40.0001L26.3636 30.1892L16.6484 40L26.3637 49.811L36.1745 40.0001ZM30.1706 53.6553L40.0001 43.8258L49.8296 53.6552L40 63.5816L30.1706 53.6553Z"
        fill="currentColor"
        fillOpacity="0.5"
      />
    </svg>
  )
}

export default Symbol
